import { render, staticRenderFns } from "./teacherModal.vue?vue&type=template&id=10d633e0&scoped=true&"
import script from "./teacherModal.vue?vue&type=script&lang=js&"
export * from "./teacherModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d633e0",
  null
  
)

export default component.exports